<span [wcCxJsonLd]="snippetImages()"></span>

<sd-arguments
  [isLoading]="isArgumentsLoading()"
  [data]="arguments()"
  [themesConfig]="themesConfig"
  [layoutTextConfig]="layoutTextConfig"
  [textConfig]="textConfig"
  [titleLevel]="1"
  [twicPicsAutoSize]="false"
/>

<wc-recipe-search [hasControl]="true" />

<!-- SEO slot -->
<cx-page-slot position="SEO" />
